export default "__VITE_ASSET__DGJOxCt0__"